import { ensureRouteInfiniteData } from '@/app/query-client'
import { newsService } from '@/features/news/api/newsService'
import { newsFeedQueryOptions } from '@/features/news/api/queries'
import { toFeedQuery } from '@/features/news/filters'
import type { RouterContext } from '@/routes/layouts/root'
import { filtersFromSearch, marketUpdateSearchSchema } from '@/screens/market/news-search'

/**
 * The `/market/update` loader: the feed's first page for the ENTRY search only (no
 * `loaderDeps`), so a filter or a keystroke re-runs no loader and `useNewsFeed`
 * (`keepPreviousData`) dims the list in place instead.
 *
 * Through `ensureRouteInfiniteData`, not `ensureRouteData`: `useNewsFeed` is an infinite query,
 * whose cache entry is an `InfiniteData` keyed on how it pages (`app/query-client.ts`).
 *
 * A URL naming an unserved sort or filter loads nothing: the feed shows the no-data state
 * (`newsService.canRequest`), so there is nothing to wait for.
 */
export async function loadMarketUpdate({
  context: { queryClient },
  location,
}: {
  context: RouterContext
  location: { search: unknown }
}): Promise<void> {
  const search = marketUpdateSearchSchema.parse(location.search)
  const query = toFeedQuery(filtersFromSearch(search), search.sort, search.query)
  if (!newsService.canRequest(query)) return
  await ensureRouteInfiniteData(queryClient, newsFeedQueryOptions(query))
}
